<template>
    <div id="warrantyForm">
        <v-card v-if="responseMessage">
            <v-card-title class="headline">Thanks! </v-card-title>
            <v-card-text>
                You have successfully been enrolled in a Home Solutions Warranty!
                Your order number is: {{newAccount}}, write it down so you don't forget.
                <hr>
                <v-btn @click="closeDialog">Close</v-btn>
            </v-card-text>

        </v-card>
        <!--<v-card v-if="loading">-->
            <!--<v-card>-->
                <!--<v-progress-circular indeterminate color="purple"></v-progress-circular>-->
            <!--</v-card>-->
        <!--</v-card>-->
        <v-card v-if="!responseMessage">
            

            <v-card-text class="px-0">
                <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                >
                    <v-layout row wrap >
                        <v-flex xs6 class="px-3" :class="{'xs12': $vuetify.breakpoint.smAndDown}">
                            <v-flex xs11 class="px-3" :class="{'xs12': $vuetify.breakpoint.smAndDown}">
                                <v-card-title class="headline">Home Warranty </v-card-title>
                                <v-layout align-center justify-center row display-3 class="menu-icon">
                                    <i class="fas fa-user center" ></i>
                                </v-layout>

                                <v-text-field
                                        name="FirstName"
                                        label="First Name"
                                        v-model="FirstName"
                                        required
                                        v-validate="'required|max:50|min:3'"
                                        :error-messages="errors.collect('FirstName')"

                                >
                                </v-text-field>
                                <v-text-field  v-validate="'required|max:50'" :error-messages="errors.collect('LastName')" name="LastName" label="Last Name" v-model="LastName" required></v-text-field>
                                <v-text-field  v-validate="'required|max:50'" :error-messages="errors.collect('AddressLine1')" name="AddressLine1" label="Address Line 1" v-model="AddressLine1" required></v-text-field>
                                <v-text-field  v-validate="'max:50'" :error-messages="errors.collect('AddressLine2')" name="AddressLine2" label="Address Line 2" v-model="AddressLine2"></v-text-field>
                                <v-text-field  v-validate="'required|max:50'" :error-messages="errors.collect('City')" name="City" label="City" v-model="City" required></v-text-field>
                                <v-select v-validate:State="'required'" :error-messages="errors.collect('State')" :items="[ 'AL', 'AZ', 'AR', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WV', 'WI' ]" name="State" label="State" v-model="State" required></v-select>
                                <v-text-field  v-validate="'required|max:50'" :error-messages="errors.collect('Country')" name="Country" label="Country" v-model="Country" required disabled></v-text-field>
                                <v-text-field  v-validate="'required|digits:5'" :error-messages="errors.collect('Zip')" name="Zip" label="Zip" v-model="Zip" required></v-text-field>
                                <v-text-field  v-validate="'email|required'" :error-messages="errors.collect('Email')" name="Email" label="Email" v-model="Email" required></v-text-field>
                                <v-text-field
                                    v-validate="'required|min:10'"
                                    mask="(###) ###-####"
                                    :masked="true"
                                    :error-messages="errors.collect('MainPhone')"
                                    name="MainPhone"
                                    label="Phone"
                                    v-model="MainPhone"
                                    required
                                >
                                </v-text-field>
                                <v-spacer></v-spacer>
                                <v-divider></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field
                                        name="AgentName"
                                        v-model="AgentName"
                                        label="Agent Name"
                                        v-validate="'max:50|min:3'"
                                        :error-messages="errors.collect('AgentName')"

                                >
                                </v-text-field>
                                <v-text-field  v-validate="'email'" v-model="AgentEmail" :error-messages="errors.collect('AgentEmail')" name="AgentEmail" label="Agent Email" required></v-text-field>
                                <div v-if="CallCenter">
                                    <v-select v-validate:HousemasterID="'required'" :error-messages="errors.collect('HousemasterID')" :items="['Franchisee', 'Call Center', 'HM Connects']" name="HousemasterID" label="How did you hear about us?" v-model="HousemasterID" required></v-select>
                                </div>

                            </v-flex>
                            <v-flex xs1>
                            </v-flex>
                        </v-flex>
                        <v-flex xs6 :class="{'xs12': $vuetify.breakpoint.smAndDown}">
                            <v-flex xs1>
                            </v-flex>
                            <v-flex px-0 xs11 :class="{'xs12': $vuetify.breakpoint.smAndDown}">
                                <div class="px-3">
                                    <v-card-title class="headline">&nbsp; </v-card-title>
                                    <v-layout align-center justify-center row display-3 class="menu-icon">
                                        <i class="fas fa-home"></i>
                                    </v-layout>
                                    <v-select :items="['Single Family', 'Multi-Unit']" v-validate:ResidenceType="'required'" :error-messages="errors.collect('ResidenceType')" label="Type of Residence" v-model="ResidenceType" name="ResidenceType" required></v-select>
                                    <v-checkbox
                                            v-model="checkbox"
                                            :label="`My home address is different from the property address`"
                                    ></v-checkbox>
                                    <div v-if="ResidenceType === 'Multi-Unit'">
                                        <v-select :items="['2', '3', '4']" :error-messages="errors.collect('NumUnits')" name="NumUnits" label="Number of Units" v-model="NumUnits" required></v-select>
                                    </div>
                                    <div v-if="checkbox">
                                        <v-text-field  v-validate="'required|max:50'" :error-messages="errors.collect('PropertyAddress1')" name="PropertyAddress1" label="Property Address 1" v-model="PropertyAddress1" required></v-text-field>
                                        <v-text-field  name="PropertyAddress2" label="Property Address 2" v-model="PropertyAddress2"></v-text-field>
                                        <v-text-field  v-validate="'required|max:50'" :error-messages="errors.collect('PropertyCity')" name="PropertyCity" label="Property City" v-model="PropertyCity" required></v-text-field>
                                        <v-select v-validate:PropertyState="'required'" :error-messages="errors.collect('PropertyState')"  :items="[ 'AL', 'AZ', 'AR', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WV', 'WI' ]" name="PropertyState" label="Property State" v-model="PropertyState" required></v-select>
                                        <v-text-field  v-validate="'required|digits:5'" :error-messages="errors.collect('PropertyZipCode')" name="PropertyZipCode" label="Property Zip Code" v-model="PropertyZipCode" required></v-text-field>
                                    </div>

                                    <div v-if="ResidenceType === 'Single Family'">
                                        <v-select :items="[ 'Between 0 and 4,999 sq feet', 'Between 5,000 and 7,499 sq feet', 'Between 7,500 and 10,000 sq feet']" v-validate="'required|max:50'" data-vv-as="SqFootage" :error-messages="errors.collect('SqFootage')" name="SqFootage" label="Property Size (Select > 5,000 if you have 2 full size kitchens)" v-model="SqFootage" required></v-select>
                                    </div>


                                    <!--<v-menu-->
                                            <!--v-model="InspectionDateMenu"-->
                                            <!--:close-on-content-click="false"-->
                                            <!--:nudge-right="40"-->
                                            <!--lazy-->
                                            <!--transition="scale-transition"-->
                                            <!--offset-y-->
                                            <!--full-width-->
                                            <!--min-width="290px"-->
                                    <!--&gt;-->
                                        <!--<template v-slot:activator="{ on }">-->
                                            <!--<v-text-field-->
                                                    <!--v-validate="'required'"-->
                                                    <!--:error-messages="errors.collect('InspectionDate')"-->
                                                    <!--v-model="InspectionDate"-->
                                                    <!--name="InspectionDate"-->
                                                    <!--label="What was the date of your home inspection?"-->
                                                    <!--prepend-icon="event"-->
                                                    <!--readonly-->
                                                    <!--v-on="on"-->
                                            <!--&gt;</v-text-field>-->
                                        <!--</template>-->
                                        <!--<v-date-picker v-model="InspectionDate" @input="validateDatePicker('InspectionDate')"></v-date-picker>-->
                                    <!--</v-menu>-->
                                    <!--<v-menu-->
                                            <!--v-model="ClosingDateMenu"-->
                                            <!--:close-on-content-click="false"-->
                                            <!--:nudge-right="40"-->
                                            <!--lazy-->
                                            <!--transition="scale-transition"-->
                                            <!--offset-y-->
                                            <!--full-width-->
                                            <!--min-width="290px"-->
                                    <!--&gt;-->
                                        <!--<template v-slot:activator="{ on }">-->
                                            <!--<v-text-field-->
                                                    <!--v-validate="'required'"-->
                                                    <!--:error-messages="errors.collect('ClosingDate')"-->
                                                    <!--name="ClosingDate"-->
                                                    <!--v-model="ClosingDate"-->
                                                    <!--label="What was the closing date for this home?"-->
                                                    <!--prepend-icon="event"-->
                                                    <!--readonly-->
                                                    <!--v-on="on"-->
                                            <!--&gt;</v-text-field>-->
                                        <!--</template>-->
                                        <!--<v-date-picker v-model="ClosingDate" @input="validateDatePicker('ClosingDate')"></v-date-picker>-->
                                    <!--</v-menu>-->
                                    <!--<v-menu-->
                                            <!--v-model="EffectiveDateMenu"-->
                                            <!--:close-on-content-click="false"-->
                                            <!--:nudge-right="40"-->
                                            <!--lazy-->
                                            <!--transition="scale-transition"-->
                                            <!--offset-y-->
                                            <!--full-width-->
                                            <!--min-width="290px"-->
                                    <!--&gt;-->
                                        <!--<template v-slot:activator="{ on }">-->
                                            <!--<v-text-field-->
                                                    <!--v-validate="'required'"-->
                                                    <!--:error-messages="errors.collect('EffectiveDate')"-->
                                                    <!--name="EffectiveDate"-->
                                                    <!--v-model="EffectiveDate"-->
                                                    <!--label="What date would you like the home warranty to become effective? (Must be within 30 days of closing and 90 days of home inspection)"-->
                                                    <!--prepend-icon="event"-->
                                                    <!--readonly-->
                                                    <!--v-on="on"-->
                                            <!--&gt;</v-text-field>-->
                                        <!--</template>-->
                                        <!--<v-date-picker v-model="EffectiveDate" :min="EarliestEffectiveDate" :max="LastEffectiveDate" @input="validateDatePicker('EffectiveDate')"></v-date-picker>-->
                                    <!--</v-menu>-->
                                </div>
                                <v-flex xs12 py-2 px-1 class="hsw-background-blue white--text hsw-calendar-group">
                                    <v-layout class="hsw-dates" row wrap >
                                        <v-flex xs4 >
                                            <v-layout align-center justify-center class="display-2 " >
                                                
                                            </v-layout>
                                            <v-menu
                                                    v-model="InspectionDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-validate="'required'"
                                                            :error-messages="errors.collect('InspectionDate')"
                                                            v-model="InspectionDate"
                                                            name="InspectionDate"
                                                            label="Inspection Date"
                                                            readonly
                                                            v-on="on"
                                                            prepend-icon="far fa-calendar-day"
                                                            class="small-label centered-input"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="InspectionDate" @input="validateDatePicker('InspectionDate')"></v-date-picker>
                                            </v-menu>

                                        </v-flex>
                                        
                                        <v-flex xs4 >
                                            <v-layout align-center justify-center class="display-2">
                                            </v-layout>
                                            <v-menu
                                                    v-model="ClosingDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-validate="'required'"
                                                            :error-messages="errors.collect('ClosingDate')"
                                                            name="ClosingDate"
                                                            v-model="ClosingDate"
                                                            label="Closing Date"
                                                            readonly
                                                            v-on="on"
                                                            prepend-icon="far fa-calendar-day"
                                                            class="small-label centered-input"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="ClosingDate" @input="validateDatePicker('ClosingDate')"></v-date-picker>
                                            </v-menu>

                                        </v-flex>

                                        <v-flex xs4 >
                                            <v-layout align-center justify-center class="display-2">
                                            </v-layout>
                                            <v-menu
                                                    v-model="EffectiveDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-validate="'required'"
                                                            :error-messages="errors.collect('EffectiveDate')"
                                                            name="EffectiveDate"
                                                            v-model="EffectiveDate"
                                                            label="Warranty Start"
                                                            readonly
                                                            v-on="on"
                                                            prepend-icon="far fa-calendar-day"
                                                            class="small-label centered-input"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="EffectiveDate" :min="EarliestEffectiveDate" :max="LastEffectiveDate" @input="validateDatePicker('EffectiveDate')"></v-date-picker>
                                            </v-menu>

                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    &nbsp;
                                </v-flex>
                                <div class="px-3">
                                    <div v-if="ResidenceType === 'Single Family'">


                                        <v-layout  row>

                                                <v-flex xs4>
                                                    <v-switch name="S246" label="Additional Freezer/Refrigerator" v-model="S246" ></v-switch>
                                                </v-flex>
                                            <v-flex xs4>
                                                <v-switch name="S145" label="Pool/Spa" v-model="S145" ></v-switch>
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-switch name="S433" label="Salt Water Pool Circuit Board & Cell" v-model="S433" ></v-switch>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-if="ResidenceType === 'Single Family'" row>
                                            <v-flex xs4>
                                                <v-switch name="S250" label="Stand Alone Spa" v-model="S250" ></v-switch>
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-switch name="S146" label="Stand Alone Ice Maker" v-model="S146" ></v-switch>
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-switch name="S251" label="Well Pump" v-model="S251" ></v-switch>
                                            </v-flex>

                                        </v-layout>
                                        <v-layout v-if="ResidenceType === 'Single Family' && SqFootage === 'Between 0 and 4,999 sq feet'" row wrap>
                                            <v-flex xs4>
                                                <v-switch name="S141" label="Central Vac" v-model="S141" ></v-switch>
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-switch name="S247" label="Garage Doors" v-model="S247" ></v-switch>
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-switch name="S142" label="Washer/Dryer" v-model="S142" ></v-switch>
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-switch name="S431" label="Kitchen Refrigerator Ice Maker" v-model="S431" ></v-switch>
                                            </v-flex>
                                        </v-layout>
                                    </div>

                                    <v-layout align-center justify-center row fill-height display-3 class="menu-icon">
                                        <i class="fas fa-credit-card"></i>
                                    </v-layout>
                                    <div class="pt-3">
                                        <strong>Your Total: ${{price}}, Your Deductible: ${{DeductibleCode}}, Length of Coverage: 15 Months</strong>
                                    </div>
                                    <v-select v-validate:TransactionType="'required'" :error-messages="errors.collect('TransactionType')"  :items="[ 'One payment up front', 'Through monthly installments over time']" name="TransactionType" label="How would you like to make your payments?" v-model="TransactionType" required></v-select>
                                    <div v-if="TransactionType === 'Through monthly installments over time'">
                                            <v-select  :items="[2, 3, 4, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]" :error-messages="errors.collect('NumberInstallments')" name="NumberInstallments" label="Number of Installments (Including down-payment)" v-model="NumberInstallments"></v-select>

                                        <div v-if="NumberInstallments">
                                            ${{DownPayment}} due today with {{NumberInstallments-1}} monthly payments of ${{DownPayment}}
                                        </div>
                                    </div>

                                    <v-select v-validate:BillingMethod="'required'" :error-messages="errors.collect('BillingMethod')" :items="PaymentOptions" ref="BillingMethod" name="BillingMethod" label="Preferred Billing Method" v-model="BillingMethod" required></v-select>

                                    <div v-if="BillingMethod === 'Credit Card'">
                                        <v-select  :items="['Visa', 'Mastercard', 'American Express', 'Discover']" v-validate="'required_if:BillingMethod,Credit Card'" name="CreditCardType" label="Credit Card Type" v-model="CreditCardType" required></v-select>
                                        <v-text-field  v-validate="'required_if:BillingMethod,Credit Card|credit_card'" :error-messages="errors.collect('CreditCardNumber')" name="CreditCardNumber" label="Card Number" v-model="CreditCardNumber" required></v-text-field>
                                        <v-text-field  v-validate="'required_if:BillingMethod,Credit Card|max:5|min:4'" mask="##/##"
                                                    :masked="true" :error-messages="errors.collect('CreditCardExpiration')" name="CreditCardExpiration" label="Expiration Date (MM/YY)" v-model="CreditCardExpiration" required></v-text-field>
                                    </div>
                                    <div v-if="BillingMethod === 'ACH'">
                                        <v-text-field  v-validate="'required_if:BillingMethod,ACH|digits:9'" :error-messages="errors.collect('RoutingNumber')" name="RoutingNumber" label="Routing Number" v-model="RoutingNumber" required></v-text-field>
                                        <v-text-field  v-validate="'required_if:BillingMethod,ACH|numeric'" :error-messages="errors.collect('AccountNumber')" name="AccountNumber" label="Account Number" v-model="AccountNumber" required></v-text-field>
                                        <v-select v-validate:AccountType="'required_if:BillingMethod,ACH'" :items="[ 'Checking', 'Savings']" :error-messages="errors.collect('AccountType')" name="AccountType" label="Account type" v-model="AccountType" required></v-select>
                                        <v-text-field  v-validate="'required_if:BillingMethod,ACH|max:50'" :error-messages="errors.collect('BankName')" name="BankName" label="Bank Name" v-model="BankName" required></v-text-field>
                                    </div>


                                    <v-btn
                                            :disabled="!valid"
                                            color="#1d506c"
                                            @click.prevent="submit"
                                            block
                                            class="white--text"
                                    >
                                        Submit
                                    </v-btn> <v-progress-circular v-if="loading" indeterminate color="red"></v-progress-circular>
                                </div>
                            </v-flex>
                            <v-flex xs2>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-form>
                <div v-if="responseError">
                    We were unable to successfully process your request. Please check your information and try again.
                    <br>
                    {{responseError}}


                </div>
            </v-card-text>

        </v-card>
    </div>
</template>

<script>
    const axios = require('axios');
    import {mask} from 'vue-the-mask'
    export default {
        directives: {mask},
        data: () => ({
            //Not part of form
            responseMessage: false,
            newAccount: null,
            valid: false,
            responseError: null,
            loading: false,
            checkbox: false,
            // Form fields
            FirstName: null,
            LastName: null,
            AddressLine1: null,
            AddressLine2: null,
            City: null,
            State: null,
            Country: "US",
            Zip: null,
            Email: null,
            MainPhone: null,
            EffectiveDate: null,
            CoverageTermMonths: '15 Months',
            FirstDueDate: null,
            NumberInstallments: null,
            InstallmentAmount: null,
            FormLanguage: null,
            ResidenceType: null,
            CreditCardType: null,
            CreditCardNumber: null,
            CreditCardExpiration: null,
            RoutingNumber: null,
            AccountNumber: null,
            AccountType: null,
            BankName: null,
            PropertyAddress1: null,
            PropertyAddress2: null,
            PropertyCity: null,
            PropertyState: null,
            PropertyZipCode: null,
            SqFootage: null,
            NumUnits: null,
            S246: null,
            S141: null,
            S247: null,
            S204: null,
            S145: null,
            S431: null,
            S433: null,
            S250: null,
            S146: null,
            S142: null,
            S251: null,
            BillingMethod: null,
            TransactionType: null,
            InspectionDate: null,
            ClosingDate: null,
            ClosingDateMenu: null,
            InspectionDateMenu: null,
            EffectiveDateMenu: null,
            HousemasterID: null,
            AgentName: null,
            AgentEmail: null

        }),

        computed: {
            price: function(){
                let total = 0;
                let base = 0;
                if(this.ResidenceType === 'Single Family') {
                    if(this.SqFootage === 'Between 7,500 and 10,000 sq feet') {
                        base = 985;
                    } else if(this.SqFootage === 'Between 5,000 and 7,499 sq feet') {
                        base = 885;
                    } else {
                        base = 635;
                    }
                } else if(this.NumUnits === '2') {
                    base = 965;
                } else if(this.NumUnits === '3') {
                    base = 1120;
                } else if(this.NumUnits === '4') {
                    base = 1400;
                }

                total += base;

                if(this.ResidenceType === 'Single Family' && this.SqFootage === 'Between 0 and 4,999 sq feet') {
                    if(this.S141 === true) total += 45;
                    if(this.S142 === true) total += 80;
                    if(this.S247 === true) total += 40;
                    if(this.S431 === true) total += 40;
                }
                if(this.S246 === true) total += 50;
                if(this.S204 === true) total += 60;
                if(this.S145 === true) total += 165;
                if(this.S433 === true) total += 250;
                if(this.S250 === true) total += 150;
                if(this.S146 === true) total += 40;
                if(this.S251 === true) total += 85;
                // if(this.PropertyState === "MD") total += 75;
                // if(this.PropertyState === "LA") total += 75;
                // if(this.PropertyState === "MI") total += 60;
                // if(this.PropertyState === "TN") total += 60;
                // if(this.PropertyState === "NV") total += 40;
                // if(this.PropertyState === "AR") total += 40;
                // if(this.PropertyState === "FL") total += 50;
                // if(this.PropertyState === "GA") total += 50;
                // if(this.PropertyState === "IN") total += 20;

                return total;
            },
            DownPayment: function () {
                let down = 0;
                if (this.TransactionType === 'Through monthly installments over time') {
                    down = (1/(parseInt(this.NumberInstallments)))*this.price;
                    down = Math.ceil(down*100)/100;
                }
                console.log(this.NumberInstallments);
                console.log(this.price);
                return down;
            },
            DeductibleCode: function () {
                if (this.ResidenceType === 'Single Family') {
                    return 75;
                }
                if (this.ResidenceType === 'Multi-Unit') return 75;
                return 0;
            },
            EarliestEffectiveDate: function () {
                let inspectionDateConstraint = new Date(this.InspectionDate);
                console.log(inspectionDateConstraint);
                let closingDateConstraint = new Date(this.ClosingDate);
                let today = new Date();
                if (today > inspectionDateConstraint && today > closingDateConstraint) {
                    let constraintMonth = today.getMonth()+1;
                    if (constraintMonth < 10) constraintMonth = "0"+constraintMonth;
                    let constraintDay = today.getDate()+1;
                    if (constraintDay < 10) constraintDay = "0"+constraintDay;
                    return inspectionDateConstraint.getFullYear()+"-"+constraintMonth+"-"+constraintDay;
                }
                if (inspectionDateConstraint > closingDateConstraint) {
                    console.log('inspection date is the constraint');
                    let constraintMonth = inspectionDateConstraint.getMonth()+1;
                    if (constraintMonth < 10) constraintMonth = "0"+constraintMonth;
                    let constraintDay = inspectionDateConstraint.getDate()+1;
                    if (constraintDay < 10) constraintDay = "0"+constraintDay;
                    console.log('constraint', inspectionDateConstraint.getFullYear()+"-"+constraintMonth+"-"+constraintDay)
                    return inspectionDateConstraint.getFullYear()+"-"+constraintMonth+"-"+constraintDay;
                } else {
                    let constraintMonth = closingDateConstraint.getMonth()+1;
                    if (constraintMonth < 10) constraintMonth = "0"+constraintMonth;
                    let constraintDay = closingDateConstraint.getDate()+1;
                    if (constraintDay < 10) constraintDay = "0"+constraintDay;
                    return closingDateConstraint.getFullYear()+"-"+constraintMonth+"-"+constraintDay;
                }
            },
            LastEffectiveDate: function () {
                let inspectionDateConstraint = new Date(this.InspectionDate);
                inspectionDateConstraint.setDate(inspectionDateConstraint.getDate() +90);
                let closingDateConstraint = new Date(this.ClosingDate);
                closingDateConstraint.setDate(closingDateConstraint.getDate() + 30);
                if (inspectionDateConstraint < closingDateConstraint) {
                    let constraintMonth = inspectionDateConstraint.getMonth()+1;
                    if (constraintMonth < 10) constraintMonth = "0"+constraintMonth;
                    let constraintDay = inspectionDateConstraint.getDate()+1;
                    if (constraintDay < 10) constraintDay = "0"+constraintDay;
                    return inspectionDateConstraint.getFullYear()+"-"+constraintMonth+"-"+constraintDay;
                } else {
                    let constraintMonth = closingDateConstraint.getMonth()+1;
                    if (constraintMonth < 10) constraintMonth = "0"+constraintMonth;
                    let constraintDay = closingDateConstraint.getDate()+1;
                    if (constraintDay < 10) constraintDay = "0"+constraintDay;
                    return closingDateConstraint.getFullYear()+"-"+constraintMonth+"-"+constraintDay;
                }
            },
            PaymentOptions: function () {
                var options = ['Credit Card', 'ACH'];
                if (this.TransactionType !== 'Through monthly installments over time') options.push('Invoice');
                return options;
            },
            CallCenter: function () {
                var host = window.location.href;
                if (host.search('callcenter') > 0) {
                    return true;
                } else {
                    return false;
                }
            }

        },
        methods: {
            validateDatePicker(datePicker){
                this.InspectionDateMenu = false;
                this.ClosingDateMenu = false;
                this.EffectiveDateMenu = false;

                this.$validator.validate(datePicker);
            },
            closeDialog() {
                this.$emit('closeTheOrderForm');
            },
            async submit() {
                this.loading = true;
                try{
                    console.log('SUBMIT CLICKED')
                    const validated = await this.$validator.validateAll();
                    console.log('VALIDATED?', validated);
                    if(!validated) {
                        this.loading = false;
                        return;
                    }
                    const host = window.location.href;
                    let env ="prod";
                    if (host.search('dev') > 0) env = 'dev';
                    console.log('environment',  env);
                    let ccnum = this.CreditCardNumber;
                    if(ccnum){
                      ccnum = ccnum.replace(new RegExp("[^0-9]", "g"), "");
                    }
                    if (!this.checkbox) {
                        this.PropertyAddress1 = this.AddressLine1;
                        this.PropertyAddress2 = this.AddressLine2;
                        this.PropertyCity = this.City;
                        this.PropertyState = this.State;
                        this.PropertyZipCode = this.Zip;
                    }
                    var AgentName = this.AgentName ? this.AgentName: null;
                    var AgentEmail = this.AgentEmail ? this.AgentEmail: null;

                    var HousemasterID = this.HousemasterID ? this.HousemasterID : "";

                    let submission = JSON.stringify({
                        "SellerCode": "A00309",
                        "AddressLine1": this.AddressLine1,
                        "Addressline2": this.Addressline2,
                        "City": this.City,
                        "State": this.State,
                        "Country": "US",
                        "Zip": this.Zip,
                        "Email": this.Email,
                        "MainPhone": this.MainPhone,
                        // "CoverageCode":
                        "EffectiveDate": this.EffectiveDate,
                        "CoverageTermMonths": this.CoverageTermMonths,
                        "AdminCode": "C00011",
                        "RetailCost": this.price,
                        "DownPayment": this.DownPayment,
                        "BillingMethod": this.BillingMethod,
                        "NumberInstallments": this.NumberInstallments-1,
                        "InstallmentAmount": this.InstallmentAmount,
                        "RoutingNumber": this.RoutingNumber,
                        "AccountNumber": this.AccountNumber,
                        "AccountType": this.AccountType,
                        "CreditCardType": this.CreditCardType,
                        "CreditCardNumber": ccnum,
                        "CreditCardExpiration": this.CreditCardExpiration,
                        "BankName": this.BankName,
                        "FirstName": this.FirstName,
                        "LastName": this.LastName,
                        "PropertyAddress1": this.PropertyAddress1,
                        "PropertyAddress2": this.PropertyAddress2,
                        "PropertyCity": this.PropertyCity,
                        "PropertyState": this.PropertyState,
                        "PropertyZipCode": this.PropertyZipCode,
                        "SqFootage": this.SqFootage,
                        "NumUnits": this.NumUnits,
                        "DeductibleCode": this.DeductibleCode,
                        "TransactionType": this.TransactionType,
                        "ResidenceType": this.ResidenceType,
                        "S246": this.S246,
                        "S141": this.S141,
                        "S247": this.S247,
                        "S204": this.S204,
                        "S145": this.S145,
                        "S431": this.S431,
                        "S433": this.S433,
                        "S250": this.S250,
                        "S146": this.S146,
                        "S142": this.S142,
                        "S251": this.S251,
                        "env": env,
                        "ClosingDate": this.ClosingDate,
                        "InspectionDate": this.InspectionDate,
                        "AgentName": AgentName,
                        "AgentEmail": AgentEmail,
                        "HousemasterID": HousemasterID
                    })


                    let url = env === 'dev' ? 'https://m94pr3ipz5.execute-api.us-east-1.amazonaws.com/dev/submit': 'https://6b1zueizo0.execute-api.us-east-1.amazonaws.com/prod/submit';

                    const result = await axios.post(url, submission);
                    this.loading = false;
                    console.log('result is: ', result);
                    console.log('Request was ', result.data.warrantyRequest);
                    console.log('New Account', result.data.newAccount);
                    console.log('FiStream\'s response: ', result.data.accountInfo);
                    if (result.data.newAccount) {
                        this.newAccount = result.data.newAccount;
                        this.responseMessage = true;
                    } else {

                        // this.responseError = result.data.accountInfo ? result.data.accountInfo: result.data.errors.toString();
                        this.responseError = result.data.errors.toString();

                    }
                }catch(e){
                    console.error(e);
                    this.loading = false;
                    this.responseError = e.message;

                }


            }
        }
    }

</script>

<style>
    .menu-icon {
        color: #3aafda;
        border: solid 5px #3aafda;
        border-radius: 12px;
    }
    .small-label .v-label{
        font-size: 12px;
        color: white;
    }
    .hsw-background-blue {
        background-color: #3aafda;
    }
    @media only screen and (max-width: 600px) {
        .hsw-calendar-group {
            border-top: solid 10px #1d516c;
            border-bottom-left-radius: 15px;
            border-bottom-right-radius: 15px;
            }
    }
    @media only screen and (min-width: 600px) {
        .hsw-calendar-group {
            position:relative;
            border-bottom-left-radius: 15px;
            border-bottom-right-radius: 15px;
            border-top-left-radius: 15px;
            border-top-right-radius: 15px;
            width:96%;
            left:2%;
        }
    }
    .hsw-dates .v-label{
        text-align: center;
        width: 100%;
        padding-left: 10.6%;
    }
    .centered-input input {
        text-align: center
    }

</style>